// Libraries
import { useTranslation } from 'react-i18next';

// MUI
import CloneIcon from '@mui/icons-material/FileCopy';

// Core
import { ResourceTextApplication } from '../../core/resources';

// Common
import { ADefaultIconButton, AIconButtonBaseProps } from '../../common/buttons';

export interface ACloneIconButtonProps extends AIconButtonBaseProps {}

export default function ACloneIconButton(props: ACloneIconButtonProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaGeneral']);
    const { tooltip, ...buttonProps } = props;
    const tooltip2 = tooltip ? tooltip : t('AnelmaGeneral:1159');

    return <ADefaultIconButton {...buttonProps} icon={<CloneIcon />} tooltip={tooltip2} />;
}
